import React from 'react';
import { FaUsers, FaLightbulb, FaChartLine, FaRegHandshake } from 'react-icons/fa';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container about-container">
        <div className="about-image-wrapper">
          <div className="image-bg-shape"></div>
          <img 
            src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=800" 
            alt="Business Experts Collaborating" 
            className="about-image"
          />
          <div className="experience-badge">
            <span className="years">10+</span>
            <span className="text">Years<br/>Experience</span>
          </div>
        </div>
        
        <div className="about-content">
          <span className="section-tag">Who We Are</span>
          <h2 className="section-title">
            Choose <span className="highlight">Nodex Global</span> For Your Business Growth
          </h2>
          <p className="about-description">
            We are a highly driven digital marketing agency that believes in creating engaging experiences through smart technological solutions. At Nodex Global LLC, we combine creativity, data, and technology to help you build brand awareness and drive more sales.
          </p>
          
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon"><FaUsers /></div>
              <div className="feature-text">
                <h4>Expert Team</h4>
                <p>Award-winning professionals</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon"><FaRegHandshake /></div>
              <div className="feature-text">
                <h4>Client-Centric</h4>
                <p>Your success is our priority</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon"><FaLightbulb /></div>
              <div className="feature-text">
                <h4>Innovative</h4>
                <p>Cutting-edge strategies</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon"><FaChartLine /></div>
              <div className="feature-text">
                <h4>Proven Results</h4>
                <p>Data-driven performance</p>
              </div>
            </div>
          </div>
          
          <div className="about-actions">
            <a href="#contact" className="btn btn-primary">Discover More</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
